(ns frontend.view.modals.curtains.sales-opportunity.events
  (:require [common.localization :as loc]
            [frontend.view.modals.events :as modals]
            [frontend.view.modals.confirmation.view :as confirmation-modal]
            [frontend.logging :as logging]
            [frontend.actions.sales-opportunity :as sales-opportunity-actions]))

(defn confirm-loss [state sales-opportunity close-modal!]
  (let [confirm-text (loc/tr :sales-opportunity-loss-curtains/confirm)]
    (modals/open-modal!
     confirmation-modal/modal-key
     {:body         [:div.text-center
                     [:p confirm-text]]
      :confirm-text (loc/tr :confirm)
      :confirm-icon ""
      :skip-checkbox? true
      :on-confirm   (fn [_]
                      (sales-opportunity-actions/*->lost!
                       {:sales-opportunity-id (:db/id sales-opportunity)
                        :loss-reason-id             (:sales-opportunity/lost-reason (:edit @state))
                        :loss-comment               (:internal-comment (:edit @state))}
                       (fn [_]
                         (close-modal!))
                       (fn [err]
                         (logging/error "Failed to set sales opportunity status to lost" err))))})))

(defn confirm-on-hold [state sales-opportunity close-modal!]
  (let [edits (:edit @state)
        {:keys [months until]} edits
        until (if (zero? months)
                until
                months)
        confirm-text (loc/tr :sales-opportunity-on-hold-curtains/confirm)]
    (modals/open-modal!
     confirmation-modal/modal-key
     {:body          [:div.text-center
                      [:p confirm-text]]
      :confirm-text  (loc/tr :confirm)
      :confirm-icon  ""
      :skip-checkbox? true
      :title         (loc/tr :submit)
      :on-confirm    (fn [_]
                       (sales-opportunity-actions/*->put-on-hold
                        {:sales-opportunity-id (:db/id sales-opportunity)
                         :on-hold-until        until
                         :on-hold-comment      (:internal-comment (:edit @state))}
                        (fn [_]
                          (close-modal!))
                        (fn [err]
                          (logging/error "Failed to set sales opportunity status to on hold" err))))})))
